import Axios from "axios";
import { api_url } from "../../../config";

// ============================================================
// Appels /operateurs (CE-1404), en français comme le contrat de l'API.
// dataService n'est pas utilisé ici : il pousserait chaque erreur en
// notification, alors que la carte demande l'erreur de validation sous le
// champ et le refus métier en bandeau. Les erreurs sont donc normalisées,
// chacune avec son `statut` HTTP (null sans réponse : réseau coupé) :
// - 400 et 419 → { champs: { nomDuChamp: message } }, ou { message } quand
//   le corps ne nomme aucun champ ;
// - 409 → { code, message, structures? } ;
// - 404 et le reste → { message }.
// ============================================================

export function normaliserErreurOperateur(err) {
  const reponse = err && err.response;
  const statut = (reponse && reponse.status) || null;
  const corps = (reponse && reponse.data) || {};
  const message = typeof corps === "string" ? corps : corps.message || corps.other;
  if (statut === 400 || statut === 419) {
    const champs = typeof corps === "object" && corps !== null ? corps : {};
    if (Object.keys(champs).length) return { statut, champs };
    return { statut, message: message || "La saisie a été refusée." };
  }
  if (statut === 409) {
    return {
      statut,
      code: corps.code || null,
      message: message || "Cette action est refusée.",
      structures: corps.structures || null,
    };
  }
  return { statut, message: message || "Une erreur est survenue" };
}

const appel = (promesse) =>
  promesse.then(
    (res) => res.data,
    (err) => Promise.reject(normaliserErreurOperateur(err))
  );

export const rechercherOperateurs = (criteres) =>
  appel(Axios.post(`${api_url}operateurs/recherche`, criteres));

export const creerOperateur = (formulaire) => appel(Axios.post(`${api_url}operateurs`, formulaire));

export const voirOperateur = (id) => appel(Axios.get(`${api_url}operateurs/${id}`));

export const modifierOperateur = (id, formulaire) =>
  appel(Axios.patch(`${api_url}operateurs/${id}`, formulaire));

export const supprimerOperateur = (id) => appel(Axios.delete(`${api_url}operateurs/${id}`));

export const mettreEnServiceOperateur = (id) =>
  appel(Axios.post(`${api_url}operateurs/${id}/mise-en-service`));

export const desactiverOperateur = (id, motif) =>
  appel(Axios.post(`${api_url}operateurs/${id}/desactivation`, { motif }));

export const reactiverOperateur = (id) =>
  appel(Axios.post(`${api_url}operateurs/${id}/reactivation`));

export const listerSitesDeOperateur = (id) =>
  appel(Axios.get(`${api_url}operateurs/${id}/sites`));

export const listerSitesOperateurs = () => appel(Axios.get(`${api_url}operateurs/sites`));

// Comptes d'un opérateur d'accompagnement (CE-1407) : routes françaises de
// CE-1365. Un compte d'opérateur ne voit que sa structure (403 ailleurs) ;
// seule la Caf crée un compte.
export const listerComptesDeOperateur = (id) =>
  appel(Axios.get(`${api_url}operateurs/${id}/comptes`));

export const creerCompteOperateur = (id, corps) =>
  appel(Axios.post(`${api_url}operateurs/${id}/comptes`, corps));

export const modifierCompteOperateur = (id, compteId, corps) =>
  appel(Axios.patch(`${api_url}operateurs/${id}/comptes/${compteId}`, corps));

export const changerActivationCompteOperateur = (id, compteId, actif) =>
  appel(Axios.post(`${api_url}operateurs/${id}/comptes/${compteId}/activation`, { actif }));

export const renvoyerLienActivationCompteOperateur = (id, compteId) =>
  appel(Axios.post(`${api_url}operateurs/${id}/comptes/${compteId}/renvoi-activation`));

// Quotas annuels par territoire (CE-1369), Caf seule : les deux routes
// rendent les années, leurs quotas et les communes desservies par territoire.
export const voirQuotasDeOperateur = (id) => appel(Axios.get(`${api_url}operateurs/${id}/quotas`));

export const fixerQuotasOperateur = (id, annee, quotas) =>
  appel(Axios.put(`${api_url}operateurs/${id}/quotas/${annee}`, { quotas }));

// Les sites d'un opérateur passent par les routes /sites existantes (clés en
// anglais), avec `operator` à la place de `organization`. Les erreurs de ces
// routes utilisent la clé `other` pour les refus : la normalisation la rabat
// sur `message`.
export const voirSite = (id) => appel(Axios.get(`${api_url}sites/${id}`));

export const creerSite = (corps) => appel(Axios.post(`${api_url}sites/`, corps));

export const modifierSite = (id, corps) => appel(Axios.patch(`${api_url}sites/${id}`, corps));

export const supprimerSite = (id) => appel(Axios.delete(`${api_url}sites/${id}`));

// Référentiels de la modale de site.
export const listerVillesReunion = () => appel(Axios.get(`${api_url}cities/reunion`));

export const listerThemes = () => appel(Axios.get(`${api_url}themes`));
